import { Icons } from '@cast/design-system';

import { useThemeColor } from 'hooks/theme';

export const IssuesIcon = () => {
  const color = useThemeColor('red.400');
  return <Icons.Warning size={16} color={color} weight="fill" />;
};
